import { render, staticRenderFns } from "./ViewWalletTransactionLog.vue?vue&type=template&id=2cce6aab&scoped=true&"
import script from "./ViewWalletTransactionLog.vue?vue&type=script&lang=js&"
export * from "./ViewWalletTransactionLog.vue?vue&type=script&lang=js&"
import style0 from "./ViewWalletTransactionLog.vue?vue&type=style&index=0&id=2cce6aab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cce6aab",
  null
  
)

export default component.exports